import React from 'react'
import { Tab, TabCounter, TabCounterText, TabsContent, TabsWrapper } from './index.styled'

const Tabs = React.memo(({ tabs, activeTab, onTabClick, className }) => {
	return (
		<TabsWrapper>
			<TabsContent>
				{tabs.map(tab =>
					<Tab key={tab.value}
							 type="button"
							 onClick={() => onTabClick(tab.value)}
							 data-testid={tab.testId}
							 className={className + ' ' + (activeTab === tab.value && 'active')}>
						{tab.title}
						{tab.counter > 0 &&
							<TabCounter className={tab.type || ''}>
								<TabCounterText className={tab.type || ''}>{tab.counter}</TabCounterText>
							</TabCounter>}
					</Tab>
				)}
			</TabsContent>
		</TabsWrapper>
	)
})

Tabs.displayName = 'Tabs'
export default Tabs
